// store.js
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		token: localStorage.getItem('token') || '',
		userId: localStorage.getItem('userId') || '',
		userName: localStorage.getItem('userName') || '',
		accountName: localStorage.getItem('accountName') || ''
    },
    mutations: {
		SET_USERINFO(state, userInfo) {
			state.userId = userInfo.accountId
			localStorage.setItem('userId', userInfo.accountId)

			state.userName = userInfo.accountName
			localStorage.setItem('userName', userInfo.accountName)

			state.accountName = userInfo.digitalCode ? `+${userInfo.digitalCode} ${userInfo.contact}` : userInfo.contact
			localStorage.setItem('accountName', state.accountName)
		},
		SET_TOKEN(state, token) {
			state.token = token
			localStorage.setItem('token', token)
		},
		REMOVE_TOKEN(state) {
			state.token = ''
			state.userId = ''
			state.userName = ''
			state.accountName = ''
			localStorage.removeItem('token')
			localStorage.removeItem('userId')
			localStorage.removeItem('userName')
			localStorage.removeItem('accountName')
		}
    },
    actions: {
		login({ commit }, userInfo){
			commit('SET_TOKEN', userInfo.accessToken)
			commit('SET_USERINFO', userInfo)
		},
		logout({ commit }) {
			commit('REMOVE_TOKEN')
		}
	}
  })